// DO NOT EDIT -- generated from fs/services/pie/overview.proto

import { IssueStatus, MetricTypes, Severity, SeverityCalculationScore, SimpleFilter } from './spotlight.proto';
import * as pagination from '../../shared/pagination';
import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';
import * as visualizationsettings from '../search-settings/visualizationsettings';

export namespace OverviewServicePublic {

  export const GetOverviewFiltersEndpoint = "/grpc/pie.OverviewServicePublic/GetOverviewFilters";
  export function GetOverviewFilters(sender: (req: GetOverviewFiltersRequest, endpoint: string) => Promise<GetOverviewFiltersResponse>, req: GetOverviewFiltersRequest): { promise: () => Promise<GetOverviewFiltersResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetOverviewFiltersEndpoint),
      endpoint: GetOverviewFiltersEndpoint
    };
  }

  export const GetOverviewMetricsEndpoint = "/grpc/pie.OverviewServicePublic/GetOverviewMetrics";
  export function GetOverviewMetrics(sender: (req: GetOverviewMetricsRequest, endpoint: string) => Promise<GetOverviewMetricsResponse>, req: GetOverviewMetricsRequest): { promise: () => Promise<GetOverviewMetricsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetOverviewMetricsEndpoint),
      endpoint: GetOverviewMetricsEndpoint
    };
  }

  export const GetOverviewOpportunitiesEndpoint = "/grpc/pie.OverviewServicePublic/GetOverviewOpportunities";
  export function GetOverviewOpportunities(sender: (req: GetOverviewOpportunitiesRequest, endpoint: string) => Promise<GetOverviewOpportunitiesResponse>, req: GetOverviewOpportunitiesRequest): { promise: () => Promise<GetOverviewOpportunitiesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetOverviewOpportunitiesEndpoint),
      endpoint: GetOverviewOpportunitiesEndpoint
    };
  }

  export const MarkOpportunityReadEndpoint = "/grpc/pie.OverviewServicePublic/MarkOpportunityRead";
  export function MarkOpportunityRead(sender: (req: MarkOpportunityReadRequest, endpoint: string) => Promise<MarkOpportunityReadResponse>, req: MarkOpportunityReadRequest): { promise: () => Promise<MarkOpportunityReadResponse>, endpoint: string } {
    return {
      promise: () => sender(req, MarkOpportunityReadEndpoint),
      endpoint: MarkOpportunityReadEndpoint
    };
  }
}

export interface GetOverviewFiltersRequest {
  orgId: string;
}

export interface GetOverviewFiltersResponse {
  funnels: SimpleFilter[];
  pages: SimpleFilter[];
  domainNames: string[];
  appNames: string[];
}

export interface OverviewFilters {
  funnelIds: string[];
  status: IssueStatus[];
  domainNames: string[];
  pageIds: number[];
  assignees: string[];
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
  severity: Severity[];
}

export interface GetOverviewMetricsRequest {
  orgId: string;
  filters: OverviewFilters | null;
}

export interface GetOverviewMetricsResponse {
  totalOpportunities: number;
  openOpportunities: number;
  inProgressOpportunities: number;
  resolvedOpportunities: number;
  lostConversions: number;
  funnelDrops: number;
}

export interface GetOverviewOpportunitiesRequest {
  orgId: string;
  pageInfo: pagination.PageInfoRequest | null;
  filters: OverviewFilters | null;
}

export interface SpikingIssue {
  insightId: string;
  instanceId: string;
  errorScore: SeverityCalculationScore;
  frictionScore: SeverityCalculationScore;
  userCount: number;
  conversionsLost: protobuf.int64;
  severity: Severity;
  title: string;
  metricType: MetricTypes;
}

export interface FunnelDrop {
  funnelId: string;
  funnelStatisticId: string;
  eventSequence: segment.EventSequence | null;
  trendStep: visualizationsettings.TrendSteps | null;
}

export interface Opportunity {
  spikingIssue?: SpikingIssue | null;
  funnelDrop?: FunnelDrop | null;
  status: IssueStatus;
  assignee: string;
  lastSeen: protobuf.timestamp | null;
  isRead: boolean;
}

export namespace Opportunity {
  export enum opportunity {
    spikingIssue = 1,
    funnelDrop = 2
  }

  export function opportunity_oneof(m: Opportunity): { opt: opportunity.funnelDrop, val: FunnelDrop } | { opt: opportunity.spikingIssue, val: SpikingIssue } | null {
    if (m.spikingIssue != null) { return { opt: opportunity.spikingIssue, val: m.spikingIssue } }
    if (m.funnelDrop != null) { return { opt: opportunity.funnelDrop, val: m.funnelDrop } }
    return null;
  }
}

export interface GetOverviewOpportunitiesResponse {
  opportunities: Opportunity[];
  pageInfo: pagination.PageInfoResponse | null;
}

export interface MarkOpportunityReadRequest {
  instanceId?: string;
  funnelStatisticId?: string;
  orgId: string;
}

export namespace MarkOpportunityReadRequest {
  export enum opportunity_id {
    instanceId = 1,
    funnelStatisticId = 2
  }

  export function opportunity_id_oneof(m: MarkOpportunityReadRequest): { opt: opportunity_id.funnelStatisticId, val: string } | { opt: opportunity_id.instanceId, val: string } | null {
    if (m.instanceId != null) { return { opt: opportunity_id.instanceId, val: m.instanceId } }
    if (m.funnelStatisticId != null) { return { opt: opportunity_id.funnelStatisticId, val: m.funnelStatisticId } }
    return null;
  }
}

export interface MarkOpportunityReadResponse {
  success: boolean;
}
